import { toast } from '../../../shared/lib/uiStore';

type ViewerManifestCapability = {
  id: string;
  label: string;
  installTarget: 'browser' | 'desktop';
  status: 'configured' | 'native-required';
};

type ViewerManifest = {
  generatedAt: string;
  deploymentMode: string;
  viewerCapabilities: ViewerManifestCapability[];
};

const VIEWER_BOOTSTRAP_KEY = 'electroplm.viewer-manifest.loaded';

export async function bootstrapViewerManifest() {
  if (typeof window === 'undefined') return;

  try {
    const response = await fetch('/viewer-manifest.json', { cache: 'no-cache' });
    if (!response.ok) return;

    const manifest = await response.json() as ViewerManifest;
    window.localStorage.setItem(VIEWER_BOOTSTRAP_KEY, manifest.generatedAt);

    const nativeRequiredCount = manifest.viewerCapabilities.filter(
      (capability) => capability.installTarget === 'desktop' && capability.status === 'native-required'
    ).length;

    const lastLoaded = window.sessionStorage.getItem(VIEWER_BOOTSTRAP_KEY);
    if (lastLoaded === manifest.generatedAt) return;

    window.sessionStorage.setItem(VIEWER_BOOTSTRAP_KEY, manifest.generatedAt);

    if (nativeRequiredCount > 0) {
      toast.info(
        'Viewer policy loaded',
        `${nativeRequiredCount} PDM viewer categories still require desktop tools on engineering workstations.`
      );
    }
  } catch {
    // Startup should not fail if the manifest is missing.
  }
}